import { TsDOM as q} from '@/scripts/core/TsDOM'
import { LocalizationForm } from '@/scripts/optional/localization-form';

q.safeDefineElement(LocalizationForm)
